export enum CustomEventName {
  ADD_NOTES_TEMPLATE = 'ADD_NOTES_TEMPLATE',
}

export interface CustomEventMap extends Event {
  [CustomEventName.ADD_NOTES_TEMPLATE]: CustomEvent<{ open: boolean }>
}
